// action types
import { DealXgSocketActions } from '../socket/dealXgSocketActionTypes';

// actions
import { Actions } from '../actionTypes/actionTypes';

// types
import type { DealRefreshDeferState } from './types';

const initialState: DealRefreshDeferState = {
    pending: false
};

export const dealRefreshDeferReducer = (
    state: DealRefreshDeferState = initialState,
    action: { type: string }
): DealRefreshDeferState => {
    switch (action.type) {
        case Actions.DEFER_DEAL_REFRESH_MODAL:
            return { ...state, pending: true };
        // Once the modal is actually shown (flushed) or the refresh is requested, the deferral is resolved.
        case DealXgSocketActions.SHOW_DEAL_REFRESH_MODAL:
        case DealXgSocketActions.REFRESH_DEAL_REQUESTED:
            return { ...state, pending: false };
        default:
            return state;
    }
};
